import { Outlet } from 'react-router-dom'

export const AppLayout = () => {
   console.debug('🚀 ~ AppLayout ~ AppLayout:')
   return <Outlet />
}
